const GLASS = {
  blur: {
    backdrop: 80,
    surface: 7,
    floating: 11,
    stacked: 11,
  },
  overlay: {
    surface: 'rgba(8, 9, 8, 0.46)',
    control: 'rgba(8, 9, 8, 0.34)',
    inset: 'rgba(8, 9, 8, 0.58)',
  },
  edge: {
    highlight: 'rgba(255, 255, 255, 0.12)',
    shadow: 'rgba(0, 0, 0, 0.42)',
  },
} as const;

type GlassDepth = keyof typeof GLASS.blur;

export { GLASS };
export type { GlassDepth };
